import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xl-4" }
const _hoisted_3 = { class: "col-xl-4" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header border-0 mt-5" }
const _hoisted_6 = { class: "card-title align-items-start flex-column" }
const _hoisted_7 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_8 = { class: "text-muted fw-bold fs-7" }
const _hoisted_9 = { class: "card-body d-flex flex-column" }
const _hoisted_10 = { class: "flex-grow-1" }
const _hoisted_11 = { class: "pt-1" }
const _hoisted_12 = { class: "text-center fs-6 pb-5 " }
const _hoisted_13 = { class: "badge badge-light-primary fs-5" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_15 = { class: "col-xl-4" }
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "card-body d-flex flex-column" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "card-body pt-2" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "form-check form-check-custom form-check-solid mx-5" }, null, -1)
const _hoisted_21 = { class: "flex-grow-1" }
const _hoisted_22 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fw-bolder fs-6"
}
const _hoisted_23 = { class: "text-muted fw-bold d-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SequenceOverview = _resolveComponent("SequenceOverview")
  const _component_AccountDetailsWidget_ECC = _resolveComponent("AccountDetailsWidget_ECC")
  const _component_apexchart = _resolveComponent("apexchart")
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_SequenceOverview),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_AccountDetailsWidget_ECC, {
          "widget-classes": "card-xl-stretch mb-5 mb-xl-8",
          "widget-color": "success"
        })
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("h3", _hoisted_6, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.eccpackagetype), 1),
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.interestRate) + "% in 8 Months", 1)
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_apexchart, {
                class: "mixed-widget-4-chart",
                options: _ctx.chartOptions,
                series: _ctx.series,
                height: "362",
                type: "radialBar"
              }, null, 8, ["options", "series"])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("p", _hoisted_12, [
                _createVNode("span", _hoisted_13, _toDisplayString(_ctx.eccmaturitymonitor.remaining) + " days left", 1),
                _hoisted_14
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              _withDirectives(_createVNode("div", null, [
                _createVNode(_component_el_skeleton, {
                  rows: 2,
                  animated: ""
                })
              ], 512), [
                [_vShow, _ctx.loadingDates]
              ]),
              _withDirectives(_createVNode("div", _hoisted_19, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.payoutDates, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: index,
                    class: [{ 'mb-8': _ctx.payoutDates.length - 1 !== index }, "d-flex align-items-center"]
                  }, [
                    _createVNode("span", {
                      class: ["bullet bullet-vertical h-40px", `bg-${item.color}`]
                    }, null, 2),
                    _hoisted_20,
                    _createVNode("div", _hoisted_21, [
                      _createVNode("a", _hoisted_22, _toDisplayString(_ctx.formatDate(item.date_to)), 1),
                      _createVNode("span", _hoisted_23, _toDisplayString(item.payout_period_m) + _toDisplayString(item.payout_period_m == 1 ? 'st' : (item.payout_period_m == 2 ? 'nd' : (item.payout_period_m == 3 ? 'rd' : 'th'))) + " Month", 1)
                    ]),
                    _createVNode("span", {
                      class: ["badge fs-8 fw-bolder", `badge-${item.color}`]
                    }, _toDisplayString(item.sts == 0 ? 'Pending' : 'Released'), 3)
                  ], 2))
                }), 128))
              ], 512), [
                [_vShow, !_ctx.loadingDates]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}